<section class="press-article">
    <div class="list">
        @if (localArticles().length === 0) {
        <p class="empty-state">{{ 'pressArticle.emptyState' | translate }}</p>
        } @else {
        @for (article of localArticles(); track article.id ?? $index; let index = $index) {
        <div class="item">
            <div class="item-content">
                <p class="quotation">{{ article.quotation }}</p>
                <a class="link" [href]="article.link" target="_blank" rel="noopener noreferrer">
                    {{ article.linkName || article.link }}
                </a>
                @if (article.author) {
                <span class="author">{{ article.author }}</span>
                }
            </div>
            <div class="item-actions">
                <mat-icon class="edit-icon" (click)="openEditForm(index)">edit</mat-icon>
                <mat-icon class="delete-icon" (click)="removeArticle(index)">delete_forever</mat-icon>
            </div>
        </div>
        }
        }
    </div>

    @if (isFormVisible()) {
    <form class="form" novalidate [formGroup]="articleForm">
        <div class="form-row">
            <label for="pressArticleQuotation">
                {{ 'pressArticle.label.quotation' | translate }} <span class="required">*</span>
            </label>
            <div class="form-input">
                <textarea
                    formControlName="quotation"
                    id="pressArticleQuotation"
                    rows="3"
                    [maxlength]="QUOTATION_MAX_LENGTH"
                ></textarea>
                @if (shouldShowError('quotation')) {
                <span class="error">{{ 'pressArticle.error.quotationRequired' | translate }}</span>
                }
            </div>
        </div>

        <div class="form-row">
            <label for="pressArticleLink">
                {{ 'pressArticle.label.link' | translate }} <span class="required">*</span>
            </label>
            <div class="form-input">
                <input formControlName="link" id="pressArticleLink" type="text" [maxlength]="LINK_MAX_LENGTH" />
                @if (shouldShowError('link')) {
                <span class="error">{{ 'pressArticle.error.linkRequired' | translate }}</span>
                }
            </div>
        </div>

        <div class="form-row">
            <label for="pressArticleAuthor">{{ 'pressArticle.label.author' | translate }}</label>
            <div class="form-input">
                <input formControlName="author" id="pressArticleAuthor" type="text" [maxlength]="AUTHOR_MAX_LENGTH" />
                @if (shouldShowError('author')) {
                <span class="error">{{ 'pressArticle.error.authorMaxLength' | translate }}</span>
                }
            </div>
        </div>

        <div class="form-row">
            <label for="pressArticleLinkName">{{ 'pressArticle.label.linkName' | translate }}</label>
            <div class="form-input">
                <input
                    formControlName="linkName"
                    id="pressArticleLinkName"
                    type="text"
                    [maxlength]="LINK_NAME_MAX_LENGTH"
                />
                @if (shouldShowError('linkName')) {
                <span class="error">{{ 'pressArticle.error.linkNameMaxLength' | translate }}</span>
                }
            </div>
        </div>

        <div class="actions">
            <button type="button" class="action-button action-button--cancel" (click)="cancelForm()">
                {{ 'pressArticle.button.cancel' | translate }}
            </button>
            <button type="button" class="action-button action-button--save" [disabled]="articleForm.invalid" (click)="saveArticle()">
                @if (formMode() === PressArticleFormMode.Edit) {
                {{ 'pressArticle.button.update' | translate }}
                } @else {
                {{ 'pressArticle.button.add' | translate }}
                }
            </button>
        </div>
    </form>
    } @else {
    <div class="add-row">
        <button type="button" class="action-button action-button--add" (click)="openAddForm()">
            <mat-icon>add</mat-icon>
            {{ 'pressArticle.button.addNew' | translate }}
        </button>
    </div>
    }
</section>
